import './Theme.css'
import { unstable_createMuiStrictModeTheme } from "@material-ui/core/styles";
export default unstable_createMuiStrictModeTheme({
    palette: {
        type: 'light',
    }
});